import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="page-content">
      <div className="container">
        <div className="row content-layout-wrapper align-items-start">
          <div className="elementor elementor-21131">
            <div
              className="wd-negative-gap elementor-element elementor-element-15a9279 e-flex e-con-boxed e-con e-parent"
              data-id="15a9279"
              data-element-type="container"
              data-settings='{"content_width":"boxed"}'
              data-core-v316-plus="true"
            >
              <div className="e-con-inner">
                <div
                  className="elementor-element elementor-element-43034055 color-scheme-inherit text-left elementor-widget elementor-widget-text-editor"
                  data-id="43034055"
                  data-element-type="widget"
                  data-widget-type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    {/* <h2><strong>Wwings Smart Technologies Pvt. Ltd.</strong></h2> */}
                    <h3><strong>Terms and Conditions</strong></h3>

                    <p><strong>1. Introduction</strong></p>
                    <p>
                      These Terms and Conditions govern your use of the Wwings Smart Technologies Pvt. Ltd. website and services.
                      By using our website and services, you accept these Terms and Conditions in full.
                      If you disagree with these Terms and Conditions or any part of these Terms and Conditions, you must not use our website or services.
                    </p>

                    <p><strong>2. License to Use Website</strong></p>
                    <p>
                      Unless otherwise stated, Wwings Smart Technologies Pvt. Ltd. owns the intellectual property rights in the website and material on the website.
                      You may view, download for caching purposes only, and print pages or other content from the website, provided that:
                    </p>
                    <ul>
                      <li>You must not republish material from this website (including republication on another website), sell, rent, or sub-license material from the website.</li>
                      <li>You must not reproduce, duplicate, copy, or otherwise exploit material on our website for a commercial purpose.</li>
                    </ul>

                    <p><strong>3. Acceptable Use</strong></p>
                    <p>
                      You must not use our website in any way that causes, or may cause, damage to the website or impairment of the availability or accessibility of the website;
                      or in any way which is unlawful, illegal, fraudulent, or harmful, or in connection with any unlawful, illegal, fraudulent, or harmful purpose or activity.
                    </p>

                    <p><strong>4. Limitation of Liability</strong></p>
                    <p>
                      The materials on Wwings Smart Technologies Pvt. Ltd.’s website are provided ‘as is’.
                      Wwings Smart Technologies Pvt. Ltd. makes no warranties, expressed or implied,
                      and hereby disclaims and negates all other warranties, including without limitation,
                      implied warranties or conditions of merchantability, fitness for a particular purpose,
                      or non-infringement of intellectual property or other violation of rights.
                    </p>

                    <p><strong>5. Revisions and Errata</strong></p>
                    <p>
                      The materials appearing on Wwings Smart Technologies Pvt. Ltd.’s website could include technical, typographical, or photographic errors.
                      Wwings Smart Technologies Pvt. Ltd. does not warrant that any of the materials on its website are accurate, complete, or current.
                    </p>

                    <p><strong>6. Changes to the Terms and Conditions</strong></p>
                    <p>
                      Wwings Smart Technologies Pvt. Ltd. may revise these Terms and Conditions of its website at any time without notice.
                      By using this website you are agreeing to be bound by the then current version of these Terms and Conditions.
                    </p>

                    <p><strong>7. Governing Law</strong></p>
                    <p>
                      These Terms and Conditions are governed by and construed in accordance with the laws of India
                      and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
                    </p>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

export default TermsOfUse;
